// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as GitHub from "../svg/GitHub.js";
import * as Gatsby from "gatsby";

import './Header.scss'
;

function Header(Props) {
  var title = Props.title;
  var github = Props.github;
  return React.createElement("header", {
              className: "top"
            }, React.createElement("div", {
                  className: "nav-box"
                }, React.createElement("div", {
                      className: "container-fluid"
                    }, React.createElement("div", {
                          className: "nav-text-title"
                        }, React.createElement(Gatsby.Link, {
                              children: title,
                              to: "/"
                            }), React.createElement("span", {
                              className: "external-link"
                            }, React.createElement(Gatsby.Link, {
                                  children: React.createElement(GitHub.make, {}),
                                  to: github
                                }))))));
}

var make = Header;

var $$default = Header;

export {
  make ,
  $$default ,
  $$default as default,
  
}
/*  Not a pure module */
